export default __webpack_public_path__ + "static/media/cycle_sport_ks2.3c627684.jpg";